import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import QuoteStep from "../../features/quote/enums/QuoteStep";
import SupportStep from "../../features/portal/enums/SupportStep";

const safeSetter = (set, get, key) => (v) => {
  try {
    set({ [key]: v });
    // Uncomment for debugging:
    // console.log(`✅ [${key}] updated with value`, get()[key]);
  } catch (err) {
    console.error(`🔥 Error setting ${key}:`, err);
  }
};

const useAppStateStore = create()(
  persist(
    (set, get) => {
      const keys = {
        // existing app/quote values
        enterAddress: false,
        showAddressLookupbtn: true,
        showVehicleLookupbtn: true,
        isManualVehicleEntry: false,
        showModel: false,
        vehicleConfirmation: false,
        vehicleConfirmationBox: false,
        showBasicLookupQuestions: false,
        showExtraLookupQuestions: false,
        newQuoteData: null,
        featuresModal: false,
        selectedCard: null,
        selectedSchemeTableId: null,
        recommendationsLoading: false,
        quoteLoading: false,
        documentsLoading: false,
        paymentsLoading: false,
        paymentProcessLoading: false,
        hideTq2Questions: false,
        isExplanationModal: false,
        ispolicyModal: false,
        modalHeading: "",

        // importing globalstore

        //navigation
        currentStep: QuoteStep.TQ1,
        previousStep: null,

        // quote steps
        additionalDriver: null,
        claims: null,
        partTime: null,
        manualBodyTypeId: null,

        // others
        documents: null,
        quoteCall: false,
        memberRetry: false,
        customerPolicies: {},
        customerQuotes: {},
        portalCustomerDataFetchedAt: null,
        portalCustomerDataKey: null,
        isValidVehicleOnNewQuote: null,
        isValidAddressOnNewQuote: null,
        lookupAddress: null,

        // AddressLookup scoped state (to allow reuse in multiple steps)
        enterAddressDriver: false,
        showAddressLookupbtnDriver: true,
        lookupAddressDriver: null,
        enterAddressGarage: false,
        showAddressLookupbtnGarage: true,
        lookupAddressGarage: null,

        // --- support values ---
        spCurrentStep: SupportStep.SP1,
        selectedOptions: [],
        supportType: "",
        cancelPolicyNavigation: true,
        isCancellationModalOpen: false,
        isChangeModalOpen: false,
        supportLoading: false,
        // --- end support values ---
      };

      // Auto-generate setters with error handling
      const setters = Object.fromEntries(
        Object.keys(keys).map((k) => [
          `set${k[0].toUpperCase()}${k.slice(1)}`,
          safeSetter(set, get, k),
        ])
      );

      // Remove support values before persisting
      const persistKeys = { ...keys };
      delete persistKeys.spCurrentStep;
      delete persistKeys.selectedOptions;
      delete persistKeys.supportType;
      delete persistKeys.cancelPolicyNavigation;
      delete persistKeys.isChangeModalOpen;

      // Add a reset method to restore initial state
      const reset = () => set({ ...keys });

      return { ...keys, ...setters, reset };
    },
    {
      name: "app-state-store",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => {
        // Only persist non-support values
        const {
          spCurrentStep,
          selectedOptions,
          supportType,
          cancelPolicyNavigation,
          isCancellationModalOpen,
          isChangeModalOpen,
          ...rest
        } = state;
        return rest;
      },
      merge: (persistedState, currentState) => {
        const mergedState = { ...currentState, ...persistedState };
        if (mergedState.currentStep === "tqStart") {
          mergedState.currentStep = QuoteStep.TQ1;
        }
        return mergedState;
      },
    }
  )
);

export default useAppStateStore;
